<div class="form-group">
  <div class="autocomplete__wrap">
    @if (showLabel && (question?.question_copy || question?.email_version)) {
      <label [innerHtml]="question?.question_copy || question?.email_version"></label>
    }
    <input
      [type]="inputType"
      [placeholder]="placeHolder"
      [value]="value"
      [id]="uniqueControlId"
      [disabled]="readOnly"
      class="form-control form-control--autocomplete"
      autocomplete="none"
      [name]="uniqueControlName"
      (input)="onInputChange($event)"
      (blur)="onBlur()">
    </div>
  </div>
